import { useErrorHandler } from '../use-error-handler';

import { useState } from 'react';

import { acceptTermsService } from '@/services';

export const useAcceptTerms = () => {
  const [loading, setLoading] = useState(false);
  const errorHandler = useErrorHandler();

  const acceptTerms = async () => {
    try {
      setLoading(true);
      await acceptTermsService();
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  return { acceptTerms, loading };
};
